(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'person', {
            bindings: {
                content:    '<'
            },
            templateUrl:  'app/views/partials/content/person.html',
            controller:   PeopleController,
            controllerAs: 'vm',

            renderingOptions: {
                'person': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    classes:       [ 'block-container', 'block__person' ],
                    wrapStart:     '<div class="centraliser">',
                    wrapEnd:       '</div>'
                }
            }
        });


    function PeopleController(
        $scope,
        TEXTS
    ){
        /** Explose to scope. */
        $scope._  = TEXTS.GENERIC.PEOPLE;
    }


    PeopleController.$inject = [ '$scope', 'TEXTS' ];
})();
